import { render, staticRenderFns } from "./airRealList.vue?vue&type=template&id=af61f900&"
import script from "./airRealList.vue?vue&type=script&lang=js&"
export * from "./airRealList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af61f900')) {
      api.createRecord('af61f900', component.options)
    } else {
      api.reload('af61f900', component.options)
    }
    module.hot.accept("./airRealList.vue?vue&type=template&id=af61f900&", function () {
      api.rerender('af61f900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/components/list/airRealList.vue"
export default component.exports